export { default } from './useIsFocusVisible';
export * from './useIsFocusVisible';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/useIsFocusVisible/index.js
// module id = 839
// module chunks = 25